import { patchComponentSchedule } from "../../helpers/utils/calendar.util";
import { SubstituteSchedulerLesson } from "./SubstituteScheduler";

/**
 * Wraps a set lesson call with the reset selected substitute on lessons modifier
 * @param setLessons A function that takes the lessons and does something with them
 */
const resetSelectedSubstitutesAdapter =
  (setLessons: (lessons: SubstituteSchedulerLesson[][]) => void) =>
  (
    lessons: SubstituteSchedulerLesson[][],
    changedLessons: SubstituteSchedulerLesson[],
  ) => {
    setLessons(resetSelectedSubstitutesModifier(lessons, changedLessons));
  };

/**
 * Resets the selected substitutes teacher on the changed lessons and patches them onto the lessons array
 * @param lessons The original lessons array that is displayed in a schedule
 * @param changedLessons Lessons that have changed
 * @returns A new array with the changed lessons integrated
 */
const resetSelectedSubstitutesModifier = (
  lessons: SubstituteSchedulerLesson[][],
  changedLessons: SubstituteSchedulerLesson[],
) => {
  return patchComponentSchedule(
    lessons,
    changedLessons.map((l) => ({ ...l, selectedSubstitute: undefined })),
  );
};

export { resetSelectedSubstitutesAdapter, resetSelectedSubstitutesModifier };
